import getDisplayDialog from '../selectors/getDisplayDialog';
import getSsoDialog from '../selectors/getSsoDialog';

export default function isAnyDialogOpen(): boolean {
    return isDisplayDialogOpen() || isSsoDialogOpen();
}

function isDisplayDialogOpen(): boolean {
    const dialog = getDisplayDialog();
    return !!dialog;
}

function isSsoDialogOpen(): boolean {
    return getSsoDialog().isOpen;
}
